module.exports = __webpack_public_path__ + "img/login3.01e01386.jpg";